export default {
  "recent_activity":"Atividade recente",
  "you_have_unfinished_invoice":"Você tem uma fatura inacabada",
  "you_have_unfinished_estimate":"Você tem um orçamento inacabado",
  "invoice":"Fatura",
  "estimate":"Orçamento",
  "home":"Início",
  "document":"Documento",
  "client":"Cliente",
  "report":"Relatório",
  "new":"Novo",
  "no_client_found":"Nenhum cliente encontrado.",
  "search":"Pesquisar",
  "clients":"Clientes",
  "documents":"Documentos",
  "no_document_found":"Nenhum documento encontrado.",
  "cancel":"Cancelar",
  "new_client":"Novo cliente",
  "add_client":"Adicionar cliente",
  "client_name_is_required":"O nome do cliente é obrigatório!",
  "client_name":"Nome do cliente",
  "email":"Email",
  "phone":"Telefone",
  "mobile":"Celular",
  "fax":"Fax",
  "address":"Endereço",
  "address_1":"Endereço 1",
  "address_2":"Endereço 2",
  "city":"Cidade",
  "state_province":"Estado/Província",
  "zip_postal_code":"CEP",
  "country":"País",
  "filter_documents":"Filtrar documentos",
  "apply_filter":"Aplicar filtro",
  "document_type":"Tipo de documento",
  "all":"Todos",
  "send_state":"Estado de envio",
  "sent":"Enviado",
  "not_sent":"Não enviado",
  "payment_state":"Estado de pagamento",
  "paid":"Pago",
  "not_paid":"Não pago",
  "overdue":"Vencido",
  "date":"Data",
  "this_month":"Este mês",
  "this_year":"Este ano",
  "custom":"Personalizado",
  "from":"De",
  "to":"Até",
  "preview":"Pré-visualizar",
  "summary":"Resumo",
  "estimate_number":"Número do orçamento",
  "issued":"Emitido",
  "valid_until":"Válido até",
  "history":"Histórico",
  "show":"Mostrar",
  "share":"Compartilhar",
  "print":"Imprimir",
  "download_pdf":"Baixar PDF",
  "send_estimate":"Enviar orçamento",
  "document_history":"Histórico do documento",
  "mark_as_paid":"Marcar como pago",
  "paid":"Pago",
  "invoice_number":"Número da fatura",
  "due":"Vencimento",
  "send_invoice":"Enviar fatura",
  "new_item":"Novo item",
  "name":"Nome",
  "price":"Preço",
  "item_name":"Nome do item",
  "item_price":"Preço do item",
  "item_name_is_required":"O nome do item é obrigatório!",
  "item_price_is_required":"O preço do item é obrigatório!",
  "item_tax_state":"Estado do imposto do item",
  "add_item":"Adicionar item",
  "new_service":"Novo serviço",
  "unit":"Unidade (Hora, Dia)",
  "service_name_is_required":"O nome do serviço é obrigatório!",
  "service_price_is_required":"O preço do serviço é obrigatório!",
  "tax":"Imposto",
  "service_tax_state":"Estado do imposto do serviço",
  "add_service":"Adicionar serviço",
  "items_and_services":"Itens e serviços",
  "items":"Itens",
  "item":"Item",
  "services":"Serviços",
  "update_item":"Atualizar item",
  "are_you_sure":"Você tem certeza?",
  "this_action_will_delete_the_item":"Esta ação excluirá o item.",
  "delete":"Excluir",
  "update":"Atualizar",
  "update_service":"Atualizar serviço",
  "this_action_will_delete_the_service":"Esta ação excluirá o serviço.",
  "business":"Empresa",
  "business_details":"Detalhes da empresa",
  "business_details_1":"Detalhes da empresa",
  "business_logo":"Logo da empresa",
  "business_name":"Nome da empresa",
  "business_name_is_required":"O nome da empresa é obrigatório!",
  "mobile_number":"Número de celular",
  "mobile_number_2":"Número de celular 2",
  "website":"Website",
  "street":"Rua",
  "street_2":"Rua 2",
  "save":"Salvar",
  "settings":"Configurações",
  "business_settings":"Configurações da empresa",
  "payment_options":"Opções de pagamento",
  "tax_settings":"Configurações de impostos",
  "document_settings":"Configurações de documentos",
  "template_design_and_settings":"Design e configurações do modelo",
  "app_settings":"Configurações do app",
  "language":"Idioma",
  "theme":"Tema",
  "dark":"Escuro",
  "light":"Claro",
  "auto":"Automático",
  "subscription":"Assinatura",
  "rate_us":"Avalie-nos",
  "paypal_email_is_required":"Email do PayPal é obrigatório",
  "online_payments":"Pagamentos online",
  "paypal":"PayPal",
  "paypal_email":"Email PayPal",
  "stripe":"Stripe",
  "payment_instructions":"Instruções de pagamento",
  "add_instructions":"Adicione instruções para receber o pagamento:\n- informações da conta bancária.\n- Venmo, Zelle, Cash App.\n- outras informações.",
  "apply_tax_to_documents":"Aplicar imposto aos documentos",
  "tax_label":"Rótulo do imposto",
  "option_1":"Opção 1 (%)",
  "option_2":"Opção 2 (%)",
  "option_3":"Opção 3 (%)",
  "itemsandservices":"Itens&Serviços",
  "preview_and_customize":"Pré-visualizar e personalizar",
  "new_estimate":"Novo orçamento",
  "add_itemandservice":"Adicionar item/serviço",
  "sub-total":"Subtotal",
  "discount":"Desconto",
  "total":"Total",
  "estimate_notes":"Notas do orçamento",
  "create_estimate":"Criar orçamento",
  "new_invoice":"Nova fatura",
  "invoice_notes":"Notas da fatura",
  "create_invoice":"Criar fatura",
  "client_details":"Detalhes do cliente",
  "save_changes":"Salvar alterações",
  "remove_this_client_from_the_document":"Remover este cliente do documento!",
  "contact":"Contato",
  "update_invoice":"Atualizar fatura",
  "item_details":"Detalhes do item",
  "remove_this_item_from_the_document":"Remover este item do documento!",
  "quantity":"Quantidade",
  "item_quantity_is_required!":"Quantidade do item é obrigatória!",
  "total_price":"Preço total",
  "service_details":"Detalhes do serviço",
  "remove_this_service_from_the_document":"Remover este serviço do documento!",
  "unit_type":"Tipo de unidade",
  "service_quantity_is_required":"Quantidade do serviço é obrigatória",
  "select_terms":"Selecionar termos",
  "taxable":"Tributável",
  "non_taxable":"Não tributável",
  "total_estimates":"Total de orçamentos",
  "total_invoices":"Total de faturas",
  "service_name":"Nome do serviço",
  "service_price":"Preço do serviço",
  "no_item_found":"Nenhum item encontrado.",
  "no_service_found":"Nenhum serviço encontrado.",
  "select_your_language":"Selecione seu idioma",
  "stripe_invoice_link":"Link da fatura Stripe",
  "update_estimate":"Atualizar orçamento",
  "sub_total":"Subtotal",
  "select_a_currency":"Selecione uma moeda",
  "reports":"Relatórios",
  "customize":"Personalizar",
  "edit":"Editar",
  "invoices":"Faturas",
  "estimates":"Orçamentos",
  "get_statement":"Obter extrato",
  "no_client_found_with_the_given_id":"Nenhum cliente encontrado com o ID fornecido.",
  "no_statement_found":"Nenhum extrato encontrado",
  "no_document_found_for_this_client":"Nenhum documento encontrado para este cliente.",
  "client_statment":"Extrato do cliente",
  "send_statment":"Enviar extrato",
  "update_client":"Atualizar cliente",
  "remove_this_item":"Remover este item",
  "remove_this_service":"Remover este serviço",
  "set_as_default":"Definir como padrão",
  "top_invoiced_clients":"CLIENTES MAIS FATURADOS",
  "amount":"Valor",
  "invoices_up":"FATURAS",
  "quarter":"Trimestre",
  "unpaid":"Não pago",
  "top_invoiced_items":"ITENS MAIS FATURADOS",
  "quantity_up":"Quantidade",
  "top_invoiced_services":"SERVIÇOS MAIS FATURADOS",
  "last_year":"Ano passado",
  "life_time":"Tempo de vida",
  "ok":"OK",
  "invoice_send_template_subject":"Fatura #{document_number} de {business_name}",
  "invoice_send_template_email":"Olá {client_name},\n \nEspero que esta mensagem o encontre bem.\n \nEmitimos uma nova fatura (#{document_number}) de {business_name}.\n \nVocê pode visualizá-la ou baixá-la com segurança usando o link abaixo:\n \n🔗 https://snapbill.app/document/{document_id}\n \nSe tiver alguma dúvida sobre esta fatura ou precisar de assistência, não hesite em nos contatar em {business_email}.\n \nObrigado pela confiança em {business_name}.\n \nAgradecemos muito o seu negócio!\n \nAtenciosamente,\n \nEquipe {business_name}",
  "estimate_send_template_subject":"Orçamento #{document_number} de {business_name}",
  "estimate_send_template_email":"Olá {client_name},\n \nEspero que esta mensagem o encontre bem.\n \nPreparamos um orçamento (#{document_number}) de {business_name} para sua análise.\n \nVocê pode visualizá-lo ou baixá-lo com segurança usando o link abaixo:\n \n🔗 https://snapbill.app/document/{document_id}\n \nSe tiver alguma dúvida, ajustes ou quiser prosseguir, basta responder a este email ou entrar em contato conosco em {business_email}.\n \nObrigado por considerar {business_name}.\n \nEstamos ansiosos para trabalhar com você!\n \nAtenciosamente,\n \nEquipe {business_name}",
  "statement_send_template_subject":"Extrato de {business_name}",
  "statement_send_template_email":"Olá {client_name},\n \nEspero que esta mensagem o encontre bem.\n \nSeu último extrato de {business_name} já está disponível.\nEste extrato fornece um resumo de suas faturas e orçamentos para sua revisão.\n \nVocê pode visualizá-lo ou baixá-lo com segurança usando o link abaixo:\n \n🔗 https://snapbill.app/statement/{statment_number}\n \nSe tiver alguma dúvida sobre este extrato ou precisar de mais detalhes, não hesite em nos contatar em {business_email}.\n \nObrigado pela confiança em {business_name}.\n \nAtenciosamente,\n \nEquipe {business_name}",
  "no_internet_connection":"Sem conexão com a Internet",
  "you_need_an_internet_connection_to_send_or_share_your_invoice":"Você precisa de uma conexão com a Internet para enviar ou compartilhar sua fatura.\nVerifique sua conexão e tente novamente mais tarde, ou escolha uma das opções offline (Imprimir ou Baixar PDF) para continuar.",
  "you_need_an_internet_connection_to_send_or_share_your_estimate":"Você precisa de uma conexão com a Internet para enviar ou compartilhar seu orçamento.\nVerifique sua conexão e tente novamente mais tarde, ou escolha uma das opções offline (Imprimir ou Baixar PDF) para continuar.",
  "you_need_an_internet_connection_to_send_or_share_your_statment":"Você precisa de uma conexão com a Internet para enviar ou compartilhar seu extrato.\nVerifique sua conexão e tente novamente mais tarde, ou escolha uma das opções offline (Imprimir ou Baixar PDF) para continuar.",
  "error":"Erro",
  "mail_composer_is_not_available_on_this_device":"O editor de email não está disponível neste dispositivo",
  "estimate_full_capital":"ORÇAMENTO",
  "invoice_full_capital":"FATURA",
  "estimate_to":"ORÇAMENTO PARA",
  "invoice_to":"FATURA PARA",
  "invoice_no":"Nº da fatura:",
  "issue_date":"Data de emissão:",
  "due_date":"Data de vencimento:",
  "valid_until":"Válido até:",
  "description":"Descrição",
  "unit_price":"Preço unitário",
  "note":"Nota:",
  "number_1":"Número 1",
  "number_2":"Número 2",
  "bill_to":"Cobrar de",
  "from_full_capital":"DE",
  "details_full_capital":"DETALHES",
  "valid": "Válido",
    "select_contact": "Selecionar contato",
    "no_contacts": "Nenhum contato encontrado",
    "import_from_contacts": "Importar dos contatos",
    "call": "Ligar",
    "message": "Mensagem",
    "success": "Sucesso",
    "pdf_saved": "PDF salvo! Abra Arquivos → No meu iPhone → SnapBill",
    "not_send": "Não enviado",
    "created": "Criado",
    "send_to": "Enviar para",
    "signatures": "Assinaturas",
    "signature": "Assinatura",
    "new_signature": "Nova assinatura",
    "signature_name_is_required": "O nome da assinatura é obrigatório",
    "clear": "Limpar",
    "delete_signature": "Excluir assinatura",
    "this_action_will_delete_the_signature": "Esta ação excluirá a assinatura.",
    "no_signatures_found": "Nenhuma assinatura encontrada",
    "add_your_signature": "Adicione sua assinatura",
    "this_action_will_remove_the_signature_from_this_document": "Esta ação removerá a assinatura deste documento.",
    "on_receipt": "Ao receber",
    "three_days": "3 dias",
    "ten_days": "10 dias",
    "thirty_days": "30 dias",
    "no_duo_date": "Sem data de vencimento",
    "no_valid_date": "Sem data válida",
    "select_date": "Selecionar data",
    "percentage": "Porcentagem",
    "fix": "Fixo",
    "please_add_client_detail_to_the_invoice": "Por favor, adiciona os dados do cliente à fatura",
    "please_add_at_least_one_item_to_the_invoice": "Por favor, adiciona pelo menos um item à fatura",
    "please_add_client_detail_to_the_estimate": "Por favor, adiciona os dados do cliente ao orçamento",
    "please_add_at_least_one_item_to_the_estimate": "Por favor, adiciona pelo menos um item ao orçamento",
    "next": "Seguinte",
    "get_started": "Começar",
    "create_invoices_and_estimates_in_seconds": "Cria faturas e orçamentos em segundos",
    "auto_fill_client_details": "Preenche automaticamente os dados do cliente, aplica modelos e envia em menos de 20 segundos.",
    "get_paid_faster_and_know_it_instantly": "Recebe o pagamento mais rápido e sê notificado de imediato",
    "snapbill_notifies_you_the_moment": "O SnapBill avisa-te no momento em que os clientes abrem a tua fatura ou iniciam o pagamento. Nada de adivinhações — apenas atualizações em tempo real e um fluxo de caixa mais rápido.",
    "see_your_business_in_full_color": "Vê o teu negócio em plena cor",
    "visualize_income_trends": "Visualiza as tendências de receita, acompanha faturas em atraso e identifica os teus melhores clientes através de relatórios claros e inteligentes que ajudam o teu negócio a crescer com confiança.",
    "unlimited_access": "Acesso ilimitado",
    "not_sure_yet": "Ainda não tens a certeza?",
    "enable_free_access": "Ativar acesso gratuito",
    "best_offer": "Melhor oferta",
    "yearly_plan": "Plano anual",
    "per_week": "por semana",
    "three_days_free_trail": "3 dias de teste gratuito",
    "weekly_plan": "Plano semanal",
    "countinue_with_three_days_free": "Continuar com 3 dias grátis",
    "countinue_with_best_offer": "Continuar com a melhor oferta",
    "privacy": "Privacidade",
    "already_subscribed": "Já estás subscrito?",
    "terms": "Termos",
    "please_select_different_plan": "Por favor, seleciona um plano diferente",
    "your_current_plan": "O teu plano atual",
    "statment_of_account": "Extrato de conta",
    "statment_date": "Data do extrato",
    "classic": "Clássico",
    "modern": "Moderno",
    "wave": "Wave",
    "estimate_no": "Orçamento n.º:",
    "pay_now":"Pagar agora",
    "copy":"Cópia",
    "copied":"Copiado",
    "invalid_stripe_invoice_link":"Link inválido para a fatura do Stripe",
    "client_name_viewed_your_invoice_document_number":"{client_name} visualizou a sua fatura n.º {document_number}",
    "client_name_viewed_your_estimate_document_number":"{client_name} visualizou o seu orçamento n.º {document_number}",
    "client_name_started_paying_invoice":"{client_name} iniciou o pagamento da fatura n.º {document_number} através de {payment_method}",
    "good_news":"Boas notícias!"
}